import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";

export default LabelProvider.create({

	Checkout: {
		k: "checkout.proceed",
		v: "Proceed to Check Out"
	},

	Continue: {
		k: "checkout.continue",
		v: "Continue Shopping"
	},

	AddToCartHeader: {
		k: "checkout.addToCart",
		v: "Added to Cart"
	},
	
	AddToYourCart: {
		k: "checkout.addToYourCart",
		v: " was added to your cart."
	},
	...filters,

	CoursesEmpty: {
	k: "entries.empty.title",
	v:"No Courses Found"
},

	DescriptionEmpty: {
		k: "entries.empty.description",
		v: "Try different search parameters."
	},

	...Messages
});



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/BundleEntries.label.ts